import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'audiences'
const verb = 'get'

export default class OspreyAudienceTotalConsumers extends BaseAction {
    constructor(dataKey) {
        const id = '980db9c1-0256-42de-99d1-5a6d1021e155'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = false
    }

    getTotalConsumers(audienceIds, contextOrn) {
        this.path = `/${resource}/estimates?audiences=${audienceIds}&X-Context-Orn=${contextOrn}`

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/audience-total-consumers.js